module.exports = __webpack_public_path__ + "static/media/Scat.svg";